import axiosInstance from '../../../helpers/axiosInstance';

export default {
  getAllApplicants: (qs = '') => axiosInstance().get('applicant/ftp', { params: qs }),
  getAllAccepted: (qs = '') => axiosInstance().get('list/accepted-applicants', { params: qs }),
  getAllScheduled: (qs = '') => axiosInstance().get('scheduled-tests', { params: qs }),
  getAllStudents: (qs = '') => axiosInstance().get('list/students', { params: qs }),
  editSingleScheduleTest: (id, data) => axiosInstance().put(`applicant-tests/${id}`, data),
};
